import { render, staticRenderFns } from "./DiagnosisFeatures.vue?vue&type=template&id=cc01efec&"
import script from "./DiagnosisFeatures.vue?vue&type=script&lang=ts&"
export * from "./DiagnosisFeatures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc01efec')) {
      api.createRecord('cc01efec', component.options)
    } else {
      api.reload('cc01efec', component.options)
    }
    module.hot.accept("./DiagnosisFeatures.vue?vue&type=template&id=cc01efec&", function () {
      api.rerender('cc01efec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/inputs/diagnosis/DiagnosisFeatures.vue"
export default component.exports